import { createContext, useContext } from 'react';

const DrawerContext = createContext();

export function useDrawer() {
  return useContext(DrawerContext);
}

export default DrawerContext;
